import React from 'react';
import { Chip, Tooltip, Typography, Box } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import {
  resolveTenantContextLabel,
  resolveTenantContextDetail,
} from '../lib/tenantContextLabel';

/**
 * Shows which company (or ShiftyPM platform) the current session operates under.
 * @param {{
 *   userData?: { role?: string, companyId?: string } | null,
 *   workspace?: { name?: string } | null,
 *   variant?: 'chip' | 'sidebar',
 * }} props
 */
export default function TenantSessionBadge({ userData, workspace, variant = 'chip' }) {
  const label = resolveTenantContextLabel(userData, workspace);
  const detail = resolveTenantContextDetail(userData, workspace);
  const tooltip = detail ? `${label} · ID: ${detail}` : `Operating as ${label}`;

  if (variant === 'sidebar') {
    return (
      <Tooltip title={tooltip} placement="right">
        <Box sx={{ textAlign: 'center', px: 1, maxWidth: '100%' }}>
          <Typography
            variant="subtitle2"
            noWrap
            sx={{ fontWeight: 700, color: 'text.primary', lineHeight: 1.3 }}
          >
            {label}
          </Typography>
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltip}>
      <Chip
        icon={<BusinessIcon fontSize="small" />}
        label={label}
        size="small"
        variant="outlined"
        sx={{ maxWidth: { xs: 140, sm: 220 }, fontWeight: 600 }}
      />
    </Tooltip>
  );
}
